export default __webpack_public_path__ + "static/media/blood3.daa6f09c.png";